export default __webpack_public_path__ + "static/media/virtual-bg15.f2b46b6d.png";